var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import Vue from 'vue';
import Component from 'vue-class-component';
import { Dependencies } from '~/core/decorator';
import { namespace } from 'vuex-class';
import { CaseApplyRecordService } from '~/services/domain-service/case-apply-record.service';
import { VisitCaseManageService } from '~/services/domain-service/visit-case-manage.service';
import { FlowTaskService } from '~/services/domain-service/flow-task.service';
import { Emit, Prop, Watch } from 'vue-property-decorator';
import { CASE_CHANNEL, ApplyType } from "~/config/enum.config";
import FileUpload from '~/components/common/file-upload.vue';
import CheckApply from "./check-apply.vue";
import { FilterService } from "~/utils/filter.service";
var CollectionExecution = namespace('collection-execution');
var Apply = /** @class */ (function (_super) {
    __extends(Apply, _super);
    function Apply() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.caseList = []; // 案件数组
        _this.model = null;
        _this.rules = null;
        _this.dialog = false;
        _this.submitLoading = false;
        _this.fileList = [];
        _this.checkMessages = {};
        return _this;
    }
    /**
     * 重置数据
     */
    Apply.prototype.resetData = function () {
        this.fileList = [];
        this.model = {
            applyCategory: '',
            applyDescription: '',
            caseIds: [],
            turnSource: '',
            pauseDueTime: '',
            repaymentType: '',
            repaymentPeriods: '',
            repayAmount: '',
            assistType: '',
            addressDetail: '',
            addressType: 'HOUSE_ADDR',
            visitEndDate: '',
            leaveDueDate: '',
            areaIds: [],
            areaId: '',
            personalAddressId: '',
            derateAmount: '',
            fileIds: [],
            confirm: 0
        };
    };
    Apply.prototype.created = function () {
        this.resetData();
        this.rules = {
            applyDescription: { required: true, message: '请输入申请原因' },
            turnSource: { required: true, message: '请选择流转去向' },
            pauseDueTime: { required: true, message: '请选择停催到期时间' },
            repaymentType: { required: true, message: '请选择划扣方式' },
            repaymentPeriods: { required: true, message: '请输入划扣期数' },
            repayAmount: { required: true, message: '请输入还款金额' },
            assistType: { required: true, message: '请选择协催类型' },
            addressType: { required: true, message: '请选择地址类型' },
            addressDetail: { required: true, message: '请输入外访地址' },
            visitEndDate: { required: true, message: '请选择协催到期时间' },
            leaveDueDate: { required: true, message: '请选择留案到期日期' },
            areaIds: { required: true, message: '请选择省份/城市/地区' },
            derateAmount: { required: true, message: '请输入申请减免金额' }
        };
    };
    Apply.prototype.emitClose = function () {
        this.checkMessages = {};
        this.resetData();
        var form = this.$refs['apply-circulation'];
        form.resetFields();
    };
    Apply.prototype.onOtherDataChange = function (val) {
        var _this = this;
        if (!val)
            return;
        if (val.assistType) {
            this.$nextTick(function () {
                _this.model.assistType = val.assistType;
            });
        }
    };
    Object.defineProperty(Apply.prototype, "assistType", {
        //过滤协催类型
        get: function () {
            // 要过滤的字段
            var disabledAssistTypes = ["LAWER_IN", "LAWER_OUT", "SELF_VISIT", "CHEAT", "LAWER"];
            // 如果是电催，将电催协催禁用
            if (this.fromChannel === CASE_CHANNEL.tel)
                disabledAssistTypes.push("ASSIT_TEL");
            // 如果是外访，将外访协催禁用
            if (this.fromChannel === CASE_CHANNEL.visit)
                disabledAssistTypes.push("ASSIT_VISIT");
            // 如果是法务，将法务协催禁用
            if (this.fromChannel === CASE_CHANNEL.legal)
                disabledAssistTypes.push("ASSIT_LEGAL");
            return this.$dict.getDictData('AssistType').filter(function (v) { return !disabledAssistTypes.includes(v.code); });
        },
        enumerable: false,
        configurable: true
    });
    Apply.prototype.refresh = function (selectionList) {
        this.caseList = selectionList;
        this.model.caseIds = this.caseList.map(function (v) { return v.id; });
    };
    /**
     * 提交前检查
     */
    Apply.prototype.commit = function () {
        var _this = this;
        var ApplyCirculation = this.$refs['apply-circulation'];
        ApplyCirculation.validate(function (valid) {
            if (!valid)
                return false;
            _this.model.confirm = 0;
            _this.commitNext();
        });
    };
    /**
     * 下一步提交，检查审批流
     */
    Apply.prototype.commitNext = function () {
        var _this = this;
        this.flowTaskService
            .checkApplyCategory({ applyCategory: this.applyType })
            .subscribe(function (data) {
            // 0 拒绝，1 提示，2 通过
            if (data.status === 1) {
                _this.$confirm("该" + _this.$dict.getDictName(_this.applyType, 'ApplyCategory') + "申请将直接生效，是否继续?", '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(function () {
                    _this.submit();
                }).catch(function () {
                    _this.submitLoading = false;
                });
            }
            else if (data.status === 2) {
                _this.submit();
            }
        }, this.error);
    };
    /**
     * 确认提交申请
     */
    Apply.prototype.confirmSubmit = function () {
        this.model.confirm = 1;
        this.submit();
    };
    /**
     * 取消继续
     */
    Apply.prototype.cancelContinue = function () {
        this.dialog = false;
        this.submitLoading = false;
    };
    /**
     * 提交申请
     */
    Apply.prototype.submit = function () {
        this.submitLoading = true;
        this.model.caseIds = this.caseIds;
        this.model.applyCategory = this.applyType;
        switch (this.applyType) {
            // 委外调账
            case ApplyType.adjustment.value:
                break;
            // 协催
            case ApplyType.assist.value:
                this.assistCollector();
                break;
            // 核销
            case ApplyType.verify.value:
                break;
            // 正常留案
            case ApplyType.leave.value:
                this.normalLeave();
                break;
            // 协催留案
            case ApplyType.assistLeave.value:
                this.assistLeave();
                break;
            //抢案共享 
            case ApplyType.robbery.value:
                this.robberyShared();
                break;
            // 暂停催收
            case ApplyType.pause.value:
                this.pause();
                break;
            // 停催激活
            case ApplyType.active.value:
                this.active();
                break;
            // 流转
            case ApplyType.turn.value:
                this.applyTurnCase();
                break;
            // 减免
            case ApplyType.derate.value:
                this.derateCase();
                break;
            // 人工扣划
            case ApplyType.repay.value:
                this.repay();
                break;
            // 回收案件
            case ApplyType.recycle.value:
                this.recyle();
                break;
            default:
                break;
        }
    };
    /**
     * 流转
     */
    Apply.prototype.applyTurnCase = function () {
        this.caseApplyRecordService
            .applyTurnCase(this.model)
            .subscribe(this.success, this.error);
    };
    /**
     * 抢案共享
     */
    Apply.prototype.robberyShared = function () {
        this.caseApplyRecordService
            .applyRobCaseShare(this.model)
            .subscribe(this.success, this.error);
    };
    /**
     * 正常留案
     */
    Apply.prototype.normalLeave = function () {
        this.model.leaveDueDate = FilterService.dateEndFormat(this.model.leaveDueDate);
        this.caseApplyRecordService
            .applyLeaveCase(this.model)
            .subscribe(this.success, this.error);
    };
    /**
     * 暂停
     */
    Apply.prototype.pause = function () {
        this.model.pauseDueTime = FilterService.dateEndFormat(this.model.pauseDueTime);
        var requestModel = this.model;
        if (this.otherData) {
            requestModel = __assign(__assign({}, this.model), this.otherData);
        }
        this.caseApplyRecordService
            .applyPauseCase(requestModel)
            .subscribe(this.success, this.error);
    };
    /**
     * 激活
     */
    Apply.prototype.active = function () {
        this.caseApplyRecordService
            .applyPauseCaseActive(this.model)
            .subscribe(this.success, this.error);
    };
    /**
     * 回收
     */
    Apply.prototype.recyle = function () {
        this.visitCaseManageService
            .returnCase(this.model)
            .subscribe(this.success, this.error);
    };
    /**
     * 协催留案
     */
    Apply.prototype.assistLeave = function () {
        this.caseApplyRecordService
            .applyAssistLeaveCase(this.model)
            .subscribe(this.success, this.error);
    };
    /**
     * 申请成功
     */
    Apply.prototype.success = function (data) {
        if (data && data.status !== 2) {
            this.checkMessages = data;
            this.dialog = true;
        }
        else {
            this.submitLoading = false;
            this.$message.success('操作成功');
            this.emitClose();
        }
    };
    /**
     * 申请失败
     */
    Apply.prototype.error = function () {
        this.submitLoading = false;
    };
    Object.defineProperty(Apply.prototype, "repaymentType", {
        get: function () {
            return this.model.repaymentType;
        },
        /**
         * 划扣时如果选择提前结清，需要清除划扣期数
         */
        set: function (val) {
            if (val !== 'MONEY') {
                this.model.repaymentPeriods = '';
            }
            this.model.repaymentType = val;
        },
        enumerable: false,
        configurable: true
    });
    /**
     * 划扣
     */
    Apply.prototype.repay = function () {
        this.model.visitEndDate = FilterService.dateEndFormat(this.model.visitEndDate);
        this.caseApplyRecordService
            .applyRepay(this.model)
            .subscribe(this.success, this.error);
    };
    Apply.prototype.pauseDueTimeChange = function () {
        var currentDay = new Date(this.model.pauseDueTime);
        var nextDay = new Date();
        if (nextDay.getDate() > this.perDueDate) {
            nextDay.setMonth(nextDay.getMonth() + 1);
        }
        nextDay.setDate(this.perDueDate);
        if (currentDay > nextDay) {
            this.$message.warning('当前选择日期超过下个账单日');
        }
    };
    /**
     * 协催
     */
    Apply.prototype.assistCollector = function () {
        this.model.areaId = this.model.areaIds[this.model.areaIds.length - 1];
        this.model.personalAddressId = this.otherData.personalAddressId;
        if (this.flag) {
            //联系人信息列表直接点击的外放协催申请
            this.model.assistType = "ASSIT_VISIT";
        }
        this.caseApplyRecordService
            .applyCaseAssist(this.model)
            .subscribe(this.success, this.error);
    };
    /**
     * 减免
     */
    Apply.prototype.derateCase = function () {
        this.model.fileIds = this.fileList.map(function (v) { return v.response.id; });
        this.caseApplyRecordService.applyDerate(this.model).subscribe(this.success, this.error);
    };
    Apply.prototype.mounted = function () { };
    __decorate([
        Dependencies(CaseApplyRecordService)
    ], Apply.prototype, "caseApplyRecordService", void 0);
    __decorate([
        Dependencies(VisitCaseManageService)
    ], Apply.prototype, "visitCaseManageService", void 0);
    __decorate([
        Dependencies(FlowTaskService)
    ], Apply.prototype, "flowTaskService", void 0);
    __decorate([
        CollectionExecution.State('perDueDate')
    ], Apply.prototype, "perDueDate", void 0);
    __decorate([
        Prop({ type: Array, required: true })
    ], Apply.prototype, "caseIds", void 0);
    __decorate([
        Prop({ type: Boolean, required: false })
    ], Apply.prototype, "flag", void 0);
    __decorate([
        Prop({ type: String })
    ], Apply.prototype, "applyType", void 0);
    __decorate([
        Prop({ type: String })
    ], Apply.prototype, "fromChannel", void 0);
    __decorate([
        Prop({ type: Object })
    ], Apply.prototype, "otherData", void 0);
    __decorate([
        Emit('close')
    ], Apply.prototype, "emitClose", null);
    __decorate([
        Watch("otherData", { immediate: true })
    ], Apply.prototype, "onOtherDataChange", null);
    Apply = __decorate([
        Component({
            components: {
                FileUpload: FileUpload,
                CheckApply: CheckApply
            },
        })
    ], Apply);
    return Apply;
}(Vue));
export default Apply;
